/**
 * ShopMint — Subtle 3D Interaction Layer (JS)
 * Adds a gentle pointer-tracked tilt to product / collection
 * cards and the hero banner image. Zero dependencies and fully
 * progressive: it does nothing on touch devices or when the
 * visitor's system prefers reduced motion.
 */
(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isTouch = window.matchMedia('(hover: none)').matches;
  if (prefersReducedMotion || isTouch) return;

  var DEFAULT_MAX_TILT = 6; // degrees

  function addTilt(el, options) {
    if (!el || el.__hasTilt) return;
    el.__hasTilt = true;

    var maxTilt = (options && options.maxTilt) || DEFAULT_MAX_TILT;
    var scale = (options && options.scale) || 1;
    var raf = null;

    function onMove(e) {
      var rect = el.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width;
      var y = (e.clientY - rect.top) / rect.height;
      var rotateY = (x - 0.5) * maxTilt * 2;
      var rotateX = (0.5 - y) * maxTilt * 2;

      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        el.style.transform =
          'rotateX(' + rotateX.toFixed(2) + 'deg) rotateY(' + rotateY.toFixed(2) + 'deg) scale(' + scale + ')';
      });
    }

    function onEnter() {
      el.classList.add('is-tilting');
    }

    function onLeave() {
      if (raf) cancelAnimationFrame(raf);
      el.style.transform = '';
      el.classList.remove('is-tilting');
    }

    el.addEventListener('mouseenter', onEnter);
    el.addEventListener('mousemove', onMove);
    el.addEventListener('mouseleave', onLeave);
  }

  function initCardTilt(root) {
    var scope = root || document;
    var cards = scope.querySelectorAll('.card-wrapper .card');
    cards.forEach(function (card) {
      addTilt(card, { maxTilt: 5, scale: 1.015 });
    });
  }

  function initBannerTilt(root) {
    var scope = root || document;
    var banners = scope.querySelectorAll('.banner__media');
    banners.forEach(function (banner) {
      addTilt(banner, { maxTilt: 2.5, scale: 1.02 });
    });
  }

  function init(root) {
    initCardTilt(root);
    initBannerTilt(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init();
  });

  // Re-scan when the theme editor swaps a section in/out, or an
  // app re-renders part of the page (e.g. collection filtering).
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
